import classes from "./ResetPassword.module.css";
import React, { useState } from "react";

import { Button, Input, Text } from "components/common";

import AuthenticationModal from "components/common/AuthenticationModal/AuthenticationModal";

const ResetPassword = ({ setStep }) => {
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [passwordMismatch, setPasswordMismatch] = useState(""); // State to handle password mismatch

  const handleResetPassword = () => {
    // Check for password mismatch
    if (password !== confirmPassword) {
      setPasswordMismatch("Passwords do not match.");
      return; // Stop further processing if passwords do not match
    } else {
      setPasswordMismatch(""); // Clear error if passwords match
    }

    setStep((prev) => prev + 1); // Proceed to the next step
  };

  return (
    <AuthenticationModal
      heading="Set Your New Password"
      info="Create a strong password to secure your account."
    >
      <div className={classes.inputWrapper}>
        <Input
          name="password"
          type="password"
          value={password}
          setValue={setPassword}
          placeholder="Password"
        />
        <Input
          name="confirmPassword"
          type="password"
          value={confirmPassword}
          setValue={setConfirmPassword}
          placeholder="Confirm New Password"
        />
        {/* Display error message if passwords don't match */}
        {passwordMismatch && (
          <Text className={classes.errorText}>{passwordMismatch}</Text>
        )}
        <Button wFull base onClick={handleResetPassword}>
          Reset Password
        </Button>
      </div>

      <div className={classes.bottomBar}>
        <Text PrimitiveTransparent60 sm textCenter>
          Back to
        </Text>
        <Button transparent to="/login" className={classes.button}>
          Login
        </Button>
      </div>
    </AuthenticationModal>
  );
};

export default ResetPassword;
